import {
  MODULE_PERMISSIONS_SCHEMA,
  DEFAULT_STAFF_PERMISSIONS,
  countPermissions,
} from "../../utils/permission";

export { MODULE_PERMISSIONS_SCHEMA, DEFAULT_STAFF_PERMISSIONS, countPermissions };

export const MODULE_CONFIG = {
  title: "Sub Administrators",
  subtitle:
    "Manage internal sub administrator accounts, assign role-based access control (RBAC), and define granular module permissions.",
  routeBase: "/staff",
  endpoints: {
    create: "staff/create",
    listing: "staff/listing",
    detail: "staff/detail",
    update: "staff/update",
    statusChange: "staff/status/change",
    delete: "staff/delete",
  },
  statusOptions: [
    { id: "all", name: "All Statuses" },
    { id: "active", name: "Active" },
    { id: "deactive", name: "Deactive" },
  ],
  statusMap: {
    active: {
      label: "Active",
      bgClass: "bg-emerald-100 text-emerald-950 border-emerald-300 font-bold",
      dotClass: "bg-emerald-600",
    },
    deactive: {
      label: "Deactive",
      bgClass: "bg-slate-100 text-slate-800 border-slate-300 font-bold",
      dotClass: "bg-slate-400",
    },
    inactive: {
      label: "Inactive",
      bgClass: "bg-slate-100 text-slate-800 border-slate-300 font-bold",
      dotClass: "bg-slate-400",
    },
  },
};

/**
 * Format date utility
 */
export const formatDate = (dateVal) => {
  if (!dateVal) return "—";
  try {
    const d = new Date(dateVal);
    if (isNaN(d.getTime())) return String(dateVal);
    return d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return String(dateVal);
  }
};

/**
 * Format time utility
 */
export const formatTime = (dateVal) => {
  if (!dateVal) return "";
  try {
    const d = new Date(dateVal);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  } catch {
    return "";
  }
};

/**
 * Capitalize string
 */
export const capitalize = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
